import React, { FC } from "react";
import { LocationName, ILocationNameProps } from "./default/LocationName"
import PersonName, { PersonNameById } from "../../sg-hpr/components/persons/PersonName";
import { IAuditListFilters } from "../interfaces/IAudit";
import { IKohderekisteri } from "@/sg-kohderekisterit/IKohderekisteri";


export interface IConfiguredComponents {
    ContextProvider: FC<{ token?: string; lang?: string; anonymousSession: boolean; registerSettings: any }>;
    LocationName: FC<ILocationNameProps>;
    LocationPicker: IKohderekisteri["LocationPicker"];
    LocationFilter?: FC<{ filters: Partial<IAuditListFilters>; onChange: (partial: Partial<IAuditListFilters>) => void; minimal?: boolean; className?: string;[key: string]: any }>;

    LocationMap: IKohderekisteri["LocationMap"];
    RenderMap: IKohderekisteri["RenderMap"];

    PersonName: typeof PersonNameById
    PersonNameBase: typeof PersonName

};


export const defaultConfiguredComponents: IConfiguredComponents = {

    ContextProvider: (props) => React.createElement("div", props),
    LocationPicker: (props) => React.createElement("div", props),

    LocationName,

    LocationMap: (props) => React.createElement("div", props),
    RenderMap: (props) => React.createElement("div", props),

    PersonName: PersonNameById,
    PersonNameBase: PersonName

};